import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";
import { SHOW_NOTIFICATION, TEMPLATE_FORM_TOGGLE_LOADING } from "../constants";
import { API } from "../constants/api";
import { axios } from "../connection/ConnectionHandler";

const formatTemplates = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => {
    const formattedItem = {
      ...item,
      label: item.name || "",
      value: item._id || "",
      date: item.date ? moment(item.date).format() : null,
      water: item.water || {},
      clothe: item.clothe || [],
      camaras: item.camaras || [],
      secado: item.secado || [],
      signature: item.signature || null,
      workDone: item.workDone || "",
      observation: item.observation || "",
    };
    return formattedItem;
  };

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

const {
  fetch: fetchTemplates,
  create: createTemplateBase,
  update: updateTemplateBase,
  delete: deleteTemplates,
} = createCrudActions("TEMPLATE", "Plantilla", formatTemplates);

export { fetchTemplates, deleteTemplates };

const syncLinkedVisitSignature = (dispatch, getState, template) => {
  const visitId = template?.visit?._id || template?.visit;
  if (!visitId) return;
  const visit = getState().visits?.[visitId] || getState().visits?.[String(visitId)];
  if (!visit) return;
  if ((visit.signature || null) === (template.signature || null)) return;
  dispatch({
    type: "UPDATE_VISIT",
    payload: {
      ...visit,
      signature: template.signature || null,
    },
  });
};

const isSuccessfulResult = (result) =>
  typeof result === "number" ||
  (result && typeof result.status === "number" && result.status < 400);

export const createTemplate = (data, opts) => async (dispatch, getState) => {
  const result = await createTemplateBase(data, opts)(dispatch, getState);
  if (isSuccessfulResult(result)) {
    syncLinkedVisitSignature(dispatch, getState, result?.data || data);
  }
  return result;
};

export const updateTemplate = (data, opts) => async (dispatch, getState) => {
  const result = await updateTemplateBase(data, opts)(dispatch, getState);
  if (isSuccessfulResult(result)) {
    syncLinkedVisitSignature(dispatch, getState, result?.data || data);
  }
  return result;
};

export const sendTemplate = (updatedTemplate) => {
  return async (dispatch) => {
    dispatch({ type: TEMPLATE_FORM_TOGGLE_LOADING });
    const response = await axios
      .put(`${API.templates.send}${updatedTemplate._id}`, updatedTemplate)
      .then((response) => {
        dispatch({ type: TEMPLATE_FORM_TOGGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "info",
            message: "Plantilla enviada.",
          },
        });
        return response.status;
      })
      .catch((err) => {
        dispatch({ type: TEMPLATE_FORM_TOGGLE_LOADING });
        return err;
      });
    return response;
  };
};
